import { DomHelper } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { Util } from "./util";
import { DEBUG } from "./config";
import { closeNestedGroupList } from "./appNestedGroup";
function appProfileRender(listNode, cardNode, parentNode, injectNode, username, bearerToken, standalone = false) {
    if (DEBUG)
        console.log("-->appProfilRender");
    const additionalClassList = ['full-width-interaction'];
    if (username.startsWith("gp000")) {
        DomHelper.alertMessage("Profilbearbeitung nicht freigeschaltet.");
        return;
    }
    else {
        getBackendData(username, "/users/profile/", "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            appProfileRDPartRender(listNode, cardNode, parentNode, injectNode, responseData.data.d, bearerToken, standalone);
        });
    }
}
function appProfileSchoolRender(listNode, cardNode, parentNode, injectNode, userResponse, username, bearerToken) {
    var _a, _b, _c, _d, _e, _f;
    if (DEBUG)
        console.log("-->appProfileSchoolRender");
    if (DEBUG)
        console.log("-->appProfilePartRender");
    let myJSON;
    if (DEBUG)
        console.log("-->appProfilePartRender part Node", parentNode);
    const infoNode = DomHelper.appendNode(parentNode, 'aside', [], []);
    DomHelper.appendNode(infoNode, 'h3', [], [], "Hinweis");
    DomHelper.appendNode(infoNode, 'p', [], [], "Daten in inaktiven Feldern sind nicht direkt änderbar. Sollten Sie hier einen Fehler feststellen, wenden Sie sich bitte an die Verwaltung Ihrer Schule.");
    const formNode = DomHelper.appendNode(parentNode, "form", ['not-disabled'], [{ attr: "id", value: "rudi-profile-form" },
        { attr: "rudi-username", value: userResponse.username }
    ]);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'givenName', 'Vorname', userResponse.name, [], true);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'sn', 'Nachname', userResponse.surname, [], true);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'odDateOfBirth', 'Geburtsdatum', Util.unixTimestamp2DateString((_a = userResponse.pupil) === null || _a === void 0 ? void 0 : _a.odDateOfBirth), [], true);
    const placeOfBirthNode = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'odPlaceOfBirth', 'Geburtsort', (_b = userResponse.pupil) === null || _b === void 0 ? void 0 : _b.odPlaceOfBirth, [], !!((_c = userResponse.pupil) === null || _c === void 0 ? void 0 : _c.odPlaceOfBirth));
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'odPLZ', 'Postleitzahl', (_d = userResponse.pupil) === null || _d === void 0 ? void 0 : _d.odPLZ, [], true);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'odCity', 'Ort', (_e = userResponse.pupil) === null || _e === void 0 ? void 0 : _e.odCity, [], true);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'mail', 'Mail', userResponse.mail, [], true);
    const emergencyContactNode = DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'odEmergencyContact', 'Notfallkontakt', (_f = userResponse.pupil) === null || _f === void 0 ? void 0 : _f.odEmergencyContact, [], false);
    const sectionButton = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    DomHelper.appendNode(sectionButton, 'button', ['btn', 'btn-primary', 'mt-2'], [{
            attr: "type",
            value: "submit"
        }], "Profil Speichern");
    sectionButton.addEventListener("click", function (event) {
        let data = {
            odEmergencyContact: emergencyContactNode.value,
            odPlaceOfBirth: placeOfBirthNode.value
        };
        event.preventDefault();
        sendBackendData('', `/users/${username.toLowerCase()}/profile`, "PUT", 'application/json', bearerToken, data, (response) => {
            closeProfileForm(listNode, cardNode, formNode, injectNode);
            DomHelper.showMessage({
                appcn: "",
                appdn: "",
                duration: 2000,
                header: "Info",
                icon: "fa-upload",
                message: "Persönliche Daten gespeichert",
                type: 'info',
                version: ""
            }, username, bearerToken);
        });
    });
}
function appProfileRDPartRender(listNode, cardNode, parentNode, injectNode, userProfile, bearerToken, standalone = false) {
    if (DEBUG)
        console.log("-->appProfilePartRender");
    let myJSON;
    if (DEBUG)
        console.log("-->appProfilePartRender part Node", parentNode);
    const formNode = DomHelper.appendNode(parentNode, "form", ['not-disabled'], [{ attr: "id", value: "rudi-profile-form" },
        { attr: "rudi-username", value: userProfile.Usrid },
        { attr: "rudi-usmsy", value: userProfile.Usmsy },
    ]);
    const patternAttrPhone = { attr: "pattern", "value": "0[0-9]+[\\/]+[0-9]+" };
    const patternAttrPhone2FA = { attr: "pattern", "value": "\\+[0-9]+[0-9]+" };
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'Telefon1', 'Telefonnr. (inkl. Vorwahl)', userProfile.Telefon1, [patternAttrPhone]);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'Fax', 'Faxnr (inkl. Vorwahl)', userProfile.Fax, [patternAttrPhone]);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'Telefon2', 'zweite Telefonnr. (inkl. Vorwahl)', userProfile.Telefon2, [patternAttrPhone]);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'TelefonSek', 'Telefonnr. Sekretariat (inkl. Vorwahl)', userProfile.TelefonSekretariat, [patternAttrPhone]);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'Mobil', 'Mobil', userProfile.Mobil, [patternAttrPhone]);
    DomHelper.appendInputText(formNode, 'rudi-profile', [], [], 'Mobil2FA', 'Mobilnr. für SMS Benachrichtigung (mobiles Arbeiten)', userProfile.SmsPasscode, [patternAttrPhone2FA]);
    let standortOptions = [];
    for (let standort of userProfile.mainToStando.results) {
        standortOptions.push({
            label: Util.getStandortLabel(standort),
            value: standort.Standort
        });
    }
    DomHelper.appendSelect(formNode, 'rudi-profile', [], 'Standort', 'Standort', standortOptions, userProfile.HauptStandort);
    let planstelleOptions = [];
    for (let planstelle of userProfile.mainToPlans.results) {
        planstelleOptions.push({
            label: planstelle.Bezeichnung,
            value: planstelle.Planstelle
        });
    }
    DomHelper.appendSelect(formNode, 'rudi-profile', [], 'Planstelle', 'Planstelle', planstelleOptions, userProfile.HauptPlanstelle);
    const sectionButton = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    DomHelper.appendNode(sectionButton, 'button', ['btn', 'btn-primary', 'mt-2'], [{
            attr: "type",
            value: "submit"
        }], "Profil Speichern");
    sectionButton.addEventListener("click", function (event) {
        appProfileRDHandleSubmit(listNode, cardNode, parentNode, injectNode, formNode, bearerToken, event, standalone);
    });
}
function appProfileRDHandleSubmit(listNode, cardNode, profileNode, injectNode, formNode, bearerToken, event, standalone = false) {
    const DEBUG = true;
    if (DEBUG)
        console.log("-->appProfileHandleSubmit", event);
    event.preventDefault();
    event.stopPropagation();
    if (event && event.target) {
        const formData = new FormData(formNode);
        const changeBody = {
            "Usmsy": formNode.getAttribute("rudi-usmsy"),
            "Usrid": formNode.getAttribute("rudi-username"),
            "Telefon1": formData.get('Telefon1'),
            "Telefon2": formData.get('Telefon2'),
            "TelefonSekretariat": formData.get('TelefonSek'),
            "Mobil": formData.get('Mobil'),
            "Fax": formData.get('Fax'),
            "SmsPasscode": formData.get('Mobil2FA'),
            "HauptPlanstelle": formData.get('Planstelle') ? formData.get('Planstelle') : "00000000",
            "HauptStandort": formData.get('Standort'),
        };
        const username = formNode.getAttribute('rudi-username');
        if (username) {
            sendBackendData(username.toLowerCase(), '/users/profile/', "PUT", "application/json", bearerToken, changeBody, function (event) {
                if (standalone) {
                    cardNode.innerHTML;
                    DomHelper.appendNode(cardNode, 'h2', [], [], "Persönliche Daten wurden gespeichert");
                    DomHelper.appendNode(cardNode, 'p', [], [], "Wenn Sie Ihre Daten nochmal ändern wollen laden Sie die Seite bitte neu.");
                    DomHelper.removeSpinner(cardNode);
                }
                else {
                    closeProfileForm(listNode, cardNode, profileNode, injectNode);
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 2000,
                        header: "Info",
                        icon: "fa-upload",
                        message: "Persönliche Daten gespeichert",
                        type: 'info',
                        version: ""
                    }, username, bearerToken);
                }
            });
            DomHelper.appendSpinner(document.getElementById('rudi-profile-form'));
        }
        else {
            console.error("No Username in FormData found");
        }
    }
}
function closeProfileForm(listNode, cardNode, profileNode, injectNode) {
    listNode.classList.remove('disabled');
    DomHelper.removeCloseSection(cardNode);
    profileNode.remove();
    DomHelper.appendCloseSection(cardNode, (event) => {
        closeNestedGroupList(cardNode, injectNode);
    });
}
export function openProfile(listNode, injectNode, cardNode, username, bearerToken, type, userResponse, standalone = false) {
    if (standalone) {
        const singleAppNode = document.getElementById('singleApp');
        if (singleAppNode) {
            singleAppNode.classList.remove('disabled');
            injectNode = singleAppNode;
        }
    }
    else {
        listNode.classList.add('disabled');
    }
    const profileNode = DomHelper.appendNode(injectNode, 'div', ['rd-profile'], []);
    DomHelper.removeCloseSection(cardNode);
    if (type === 'school') {
        appProfileSchoolRender(listNode, cardNode, profileNode, injectNode, userResponse, username, bearerToken);
    }
    else if (type === 'rd') {
        appProfileRender(listNode, cardNode, profileNode, injectNode, username, bearerToken, standalone);
    }
    DomHelper.appendCloseSection(cardNode, (event) => {
        closeProfileForm(listNode, cardNode, profileNode, injectNode);
    });
}
